import "./MybookingCard.css";
import { BiQrScan } from "react-icons/bi";
import { FaCalendarAlt } from "react-icons/fa";
import { IoTimeOutline } from "react-icons/io5";
import { FiUsers } from "react-icons/fi";
import { FaLocationDot } from "react-icons/fa6";
import RSVPList from "./RSVPList";
import MyBookingQRModal from "./MyBookingQRModal";
import { useState } from "react";
import { API_BASE_URL } from "../../utils";
import MyBookingReviewModel from "./MyBookingReviewModel";
import { IoQrCode } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";

const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function MybookingCard({ data, isHistory }) {

    const navigate = useNavigate();

    const [showQR, setShowQR] = useState(false);
    const [showReview, setShowReview] = useState(false);

    return (
        <>
            {data === undefined ? (<>
                <div className="mybooking-card-section">
                    <div className="mybooking-card-container">
                        <div className="mybooking-card-content">
                            <div className="mybooking-card-content-text-no-data">
                                <p>No data</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>) : (
                <div className="mybooking-card-section">
                    <div className="mybooking-card-container">
                        <div className="mybooking-card-content">
                            <div className="mybooking-card-content-img">
                                <img src={url + data?.clubLogo} alt="" />
                            </div>
                            <div className="mybooking-card-content-text">
                                <div className="mcct-title-section">
                                    <h1 className="mcct-title">{data?.clubName}</h1>

                                </div>
                                <div className="mcct-venue">
                                    <p>Veggies Garden Palace</p>
                                </div>
                                <div className="mcct-date-time-guest">
                                    <p><FaCalendarAlt /> {data?.party_date}</p>
                                    <p> <IoTimeOutline /> 10PM - 1AM</p>
                                    <p>
                                        <FiUsers />{" "}
                                        {(Number(data?.male_qty) || 0) +
                                            (Number(data?.female_qty) || 0) +
                                            (Number(data?.kids_qty) || 0)}
                                    </p>

                                </div>
                                <div className="mcct-address">
                                    <p><FaLocationDot /> {data?.address}</p>

                                </div>


                                <div className="mcct-amount-section">
                                    {isHistory ? (
                                        <div className="mcct-amount-paid">
                                            <span className="mcct-amount-section-text-1">Paid</span>
                                            <span className="mcct-amount-section-text-2">INR {data?.net_payable_amount}</span>
                                        </div>
                                    ) : (
                                        <div className="mcct-amount-paid-btn">
                                            <Link to={`/add-menu/${data?.order_id}`} style={{ textDecoration: "none" }}>
                                           <button className="mmct-menu-guest-button">Update Menu</button>
                                            </Link>
                                            <Link to={`/add-guest/${data?.order_id}`} style={{ textDecoration: "none" }}>
                                           <button className="mmct-menu-guest-button">Invite Guest List</button>
                                            </Link>
                                        </div>
                                    )}

                                    <div className="mcct-amount-section-buttons-mobile">
                                        <div
                                            className="mcct-qr"
                                            onClick={() => navigate(`/my-bookings-details/${data?.order_id}`)}
                                        >
                                            View Details
                                        </div>


                                        <div>
                                            {isHistory ? (
                                                <button className="mcct-balance-to-paid" onClick={() => setShowReview(true)}>
                                                    <span className="mcct-amount-section-text-review" >Review</span>
                                                </button>
                                            ) : (
                                                <button className="mcct-balance-to-paid">
                                                    <span className="mcct-amount-section-text-1">Balance </span>
                                                    <span className="mcct-amount-section-text-paid">INR {data?.due_amount}</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>


                                </div>

                            </div>


                            <div className="mcct-amount-section-buttons">
                                <div className="mcct-qr-section-view">
                                    <div
                                        className="mcct-qr"
                                        onClick={() => navigate(`/my-bookings-details/${data?.order_id}`)}
                                    >
                                        <IoQrCode size={30} />

                                        View Details
                                    </div>


                                </div>
                                <div>
                                    {isHistory ? (
                                        <>
                                            <button className="mcct-balance-to-paid" onClick={() => setShowReview(true)}>
                                                <span className="mcct-amount-section-text-review" >Review</span>
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <span className="mcct-amount-section-text-1">Balance </span>
                                            <button className="mcct-balance-to-paid">
                                                <span className="mcct-amount-section-text-paid">INR {data?.due_amount}</span>
                                            </button>
                                             <div className="mcct-amount-paid">
                                          
                                            <span className="mcct-amount-section-text-2"><span className="mcct-amount-section-text-1"> Paid </span>INR {data?.net_payable_amount}</span>
                                        </div>
                                        </>
                                    )}
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            )}
            <MyBookingQRModal show={showQR} onClose={() => setShowQR(false)} />
            <MyBookingReviewModel show={showReview} onClose={() => setShowReview(false)}
            />
        </>
    )
}
